import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account', {
        url: '/manage-account/:accountId',
        redirectTo: 'company.user-directories.manage-account.details',
        component: 'companyUserDirectoriesManageAccount',
        resolve: {
            $breadcrumbs,
            account,
            accountId,
        },
    });
}

/** @ngInject */
function $breadcrumbs(account) {
    return [
        {
            stateName: 'company.user-directories.directory-groups',
        },
        {
            stateName: 'company.user-directories.directory-groups.directory',
            stateParams: {directoryId: (account.directory || {}).id},
            title: (account.directory || {}).name || 'SAASPASS Cloud Directory',
        },
        {
            title: account.username,
        },
    ];
}

/** @ngInject */
function account(accountId, AccountsResource, companyId) {
    return AccountsResource.getUserAccount(companyId, accountId);
}

/** @ngInject */
function accountId($stateParams) {
    return $stateParams.accountId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/manage-account.state.js